import Box from '@mui/material/Box';
import { SnackbarProvider as NotistackSnackbarProvider, useSnackbar } from 'notistack';
import { ReactNode } from 'react';

// --------------------------------------------------------------------------------------

interface CloseButtonProps {
  snackbarKey: any;
}

function SnackbarCloseButton({ snackbarKey }: CloseButtonProps) {
  const { closeSnackbar } = useSnackbar();

  const handleOnClose = () => {
    closeSnackbar(snackbarKey);
  };

  return (
    <Box
      onClick={handleOnClose}
      sx={{
        backgroundColor: 'transparent',
        position: 'absolute',
        left: 10,
        height: 30,
        width: 30,
      }}
    />
  );
}

// --------------------------------------------------------------------------------------

interface SnackBarProps {
  children: ReactNode;
}

const CustomSnackbarProvider = ({ children }: SnackBarProps) => (
  <NotistackSnackbarProvider
    action={(snackbarKey) => <SnackbarCloseButton snackbarKey={snackbarKey} />}
  >
    {children}
  </NotistackSnackbarProvider>
);

export default CustomSnackbarProvider;
